export default function initProductSlider() {
  document.querySelectorAll(".wilo-category-slider").forEach((element) => {
    const buttons = element.querySelectorAll(".category-tab");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        buttons.forEach((button) =>
          button.setAttribute("aria-selected", "false")
        );

        button.setAttribute("aria-selected", "true");

        const reference = button.getAttribute("aria-controls");
        if (!reference) {
          console.warn(
            "no reference given in product category slider - aborting."
          );

          return;
        }
        const panels = element.querySelectorAll(".category-panel");

        panels.forEach((panel) => panel.classList.remove("active"));

        const panel = document.querySelector(`#${reference}`);
        if (!panel) {
          console.warn(
            "no reference given in product category slider - aborting."
          );

          return;
        }

        panel.classList.add("active");
      });
    });
  });
}
